export default {"src":"/_next/static/media/pubgenLogo_dark.e8d97159.svg","height":4564,"width":25036,"blurWidth":0,"blurHeight":0};